const THREE = require('three')
let modifiers = require('src/lib/modifiers.js')
import {loadingManager, load, registerSize} from '../loader'
import raf from '../raf'
import {TweenMax, Cubic} from 'gsap'

const clothUrl = require('src/assets/result/cloth.png')
registerSize(clothUrl, 155176)


let geometry = new THREE.PlaneGeometry(300, 150, 24, 24)

let material = new THREE.MeshBasicMaterial({
  side: THREE.DoubleSide,
  transparent: true
})
material.depthTest = false
material.depthWrite = false

export let mesh = new THREE.Mesh(geometry, material)
export default mesh
mesh.name = 'cloth'
// mesh.position.x = 15


const loader = new THREE.TextureLoader(loadingManager)
load(clothUrl, loader, (results)=> {
  material.map = results[0]
  material.needsUpdate = true
})



let clothModifier = new modifiers.Cloth(2, 0.2) // rigidity, friction
setTimeout(()=> {
  clothModifier.lockXMin(0)
  clothModifier.setForce(0.2, -0.05, -0.05)
})


let modifierStack = new modifiers.ModifierStack(mesh)
modifierStack.addModifier(clothModifier)


// ANIMATION
export let update = function(delta) {
  modifierStack && modifierStack.apply()
}
// raf.on('tick', update)



// let force = {x: 0.15, y: -0.03, z: -0.03}
// // let force = {x: 0, y: 0, z: 0}
// TweenMax.to(force, 5, {
//   x: 0.1,
//   y: 0.05,
//   z: 0.05,
//   yoyo: true,
//   repeat: -1,
//   ease: Cubic.easeIn,
//   onUpdateParams: ['{self}'],
//   onUpdate: (tween)=> {
//     const f = tween.target
//     clothModifier.setForce(f.x, f.y, f.z)
//   }
// })




// WEBPACK FOOTER //
// ./src/components/game/result/cloth.js